import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getCompanyMSTeamMemberListData } from './mockData'
import type { THrid } from '~/types/models'
import type { ICompanyMSTeamMember } from '@/types/company/models'

interface GetCompanyMSTeamMembersResponse {
  data: ICompanyMSTeamMember[] | undefined
}

// post

const postCompanyMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getCompanyMSTeamMemberListData)
}

const patchCompanyMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getCompanyMSTeamMemberListData)
}

const deleteCompanyMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getCompanyMSTeamMemberListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/companymsteammembers',
    handler: postCompanyMSTeamMember,
  },
  {
    method: 'patch',
    path: '/api/companymsteammembers/:id',
    handler: patchCompanyMSTeamMember,
  },
  {
    method: 'delete',
    path: '/api/companymsteammembers/:id',
    handler: deleteCompanyMSTeamMember,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
